import { createSelector } from '@ngrx/store';

import { selectRegistration } from './registration.selectors';
import { RegistrationState } from '../../models/registration.model';

export const selectComplete = createSelector(selectRegistration, (state: RegistrationState) =>
  state ? state.complete : undefined,
);
